import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import { hideModal } from '../../../actions/modal';
import ProductSizeUpdation from './ProductSizeUpdation';

import { sendEvent } from '../../../utils/dataGrinch.js';
import { getPageInfo } from '../../../utils/pageInfo.js';
import { calculatePriceInfo } from '../../../utils/products.js';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import {
  getNewSizeRevampFlag,
  getShowBrandSizeFlag,
  getLuxeFlags
} from '../../../Flags/selectors.js';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getProductItemForCart, gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { readCookie } from '../../../components/common/Cookie';

const { cart: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;
class ProductUpdationPopup extends React.Component {
  constructor(props) {
    super(props);
    this.config = {
      min: 1,
      max: 10
    };
    this.state = {
      currentCount: 0,
      oldQuantity: 0,
      selectSize: false
    };
    this.textContent = {
      selectQuantity: 'Select quantity'
    };
  }

  componentWillMount() {
    const { quantity = 0, newDesignLuxe } = this.props;

    this.setState({ currentCount: quantity, oldQuantity: quantity });
    if (newDesignLuxe) {
      gtmEventPush({
        event: 'size_change_cart',
        event_category: 'bag interactions',
        event_action: 'size change',
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
    }

    segmentEventPush({
       event: 'Size Updated',       
       screen_name: screenName,
       screen_type: screenType,
       cart_id: readCookie('C'),
       products:[
        {
          ...getProductItemForCart(this.props?.itemData)
        }
       ]

    })

  }

  setSelectedSizeValue = () => {
    this.setState({ selectSize: true });
  };

  changeQuantity(changeType = 'decrement') {
    const { newDesignLuxe } = this.props;
    if (changeType === 'decrement' && this.state.currentCount - 1 > 0) {
      this.setState({ currentCount: this.state.currentCount - 1 });
    } else if (changeType === 'increment' && this.state.currentCount + 1 <= 10) {
      this.setState({ currentCount: this.state.currentCount + 1 });
    }

    if (newDesignLuxe) {
      gtmEventPush({
        event: 'quanity_change_cart',
        event_category: 'bag interactions',
        event_action: 'quantity change',
        event_label: changeType,
        store_type: luxeStore,
        screen_name: screenName,
        screen_type: screenType
      });
    }
    segmentEventPush({
      event: 'Product Quantity Updated',    
      order_id : readCookie('C'),
      //order_status
      //previous_screen_name
      product_id : code,
      screen_name : 'Cart Page',      
      
    })
  }

  updateProductForDataGlinch = () => {
    const { code = '', size, priceInfo = {} } = this.props;

    const { Price, Discount } = calculatePriceInfo(priceInfo);

    const { currentCount } = this.state;

    const eventObj = [];

    eventObj.ProductId = code;
    eventObj.NewQuantity = currentCount;
    eventObj.NewSize = size;

    eventObj.Price = Price;
    eventObj.Discount = Discount;

    const { pageId, pageType } = getPageInfo(location.pathname || '');
    eventObj.pageId = pageId;
    eventObj.pageType = pageType;
    sendEvent('ProductUpdate', eventObj);
    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Change_Quantity,
      eventObj: {
        New_Quantity: currentCount
      }
    });
  };

  render() {
    const {
      quantity = 0,
      entryNumber = -1,
      code = '',
      modalName = '',
      size,
      sizeDetails = [],
      dealEnabled = false,
      newSizeRevampFlag,
      showBrandSizeFlag,
      beautyVolume = '',
      hideSizes = false,
      newDesignLuxe,
      itemData = {}
    } = this.props;
    const { selectSize, currentCount, oldQuantity } = this.state;
    let disableUpdateButton = true;

    if (selectSize || currentCount !== oldQuantity) {
      disableUpdateButton = false;
    }

    let sizeVariantOptions = [];
    (sizeDetails.baseOptions || []).forEach((variant, i) => {
      if (variant.variantType === 'FnlSizeVariant') {
        sizeVariantOptions = variant.options;
      }
    });
    const productList = [];
    sizeVariantOptions.forEach(({ code, stock }) => {
      productList.push({ code, stock });
    });
    const [{ stock: { stockLevel } = {} } = {}] = (productList || []).filter(
      ({ code: productCode }) => productCode === size
    );
    if (stockLevel < currentCount) {
      disableUpdateButton = true;
    }

    let isSelectedSizeIsOOS = false;
    if (sizeVariantOptions && sizeVariantOptions.length) {
      const cartStockCheck =
        sizeVariantOptions.find(({ code: sizeCode }) => sizeCode === size) || {};
      if (cartStockCheck && cartStockCheck.stock) {
        const { stockLevel: stock } = cartStockCheck.stock;
        if (stock === 0) {
          isSelectedSizeIsOOS = true;
        }
      }
    }

    let isProductIsOOS = false;
    if (sizeVariantOptions && sizeVariantOptions.length) {
      isProductIsOOS = sizeVariantOptions.every(({ stock: { stockLevel } }) => stockLevel === 0);
    }
    if (isProductIsOOS) {
      disableUpdateButton = true;
    }

    return (
      <div>
        <div id="cardSizePopup">
          <ProductSizeUpdation
            code={code}
            setSelectedSizeValue={this.setSelectedSizeValue}
            size={size}
            sizeDetails={sizeDetails}
            newSizeRevampFlag={newSizeRevampFlag}
            showBrandSizeFlag={showBrandSizeFlag}
            hideSizes={beautyVolume || hideSizes}
            newDesignLuxe={newDesignLuxe}
          />
        </div>
        <div id="cardQtyPopup">
          {!dealEnabled ? (
            <div className="cartqty-section">
              <p className="header-label" role="heading" aria-level={2} id="quantity-group-label">
                {this.textContent.selectQuantity}
              </p>

            <div role="group" aria-labelledby="quantity-group-label">
              <button
                className={newDesignLuxe ? 'luxe-newdesign-decrement button' : 'decrement button'}
                onClick={() => this.changeQuantity('decrement')}
                disabled={isProductIsOOS || currentCount <= this.config.min}
                aria-label="Decrease quantity"
              >
                {' '}
                -{' '}
              </button>

              <div
                className={newDesignLuxe ? 'luxe-newdesign-counter' : 'counter'}
                role="status"
                aria-live="polite"
                aria-atomic="true"
              >
                {' '}
                {currentCount}{' '}
              </div>

              <button
                className={newDesignLuxe ? 'luxe-newdesign-increment button' : 'increment button'}
                onClick={() => this.changeQuantity('increment')}
                disabled={
                  isProductIsOOS ||
                  currentCount + 1 >
                    (stockLevel !== 'undefined'
                      ? Math.min(this.config.max, stockLevel)
                      : this.config.max)
                }
                aria-label="Increase quantity"
              >
                {' '}
                +{' '}
              </button>
            </div>
              {stockLevel !== undefined && stockLevel >= currentCount && stockLevel <= 10 && (
                <p className="available-error-msg">
                  <span className="availablily-message">{stockLevel} left </span>
                </p>
              )}
              {!!stockLevel && stockLevel < currentCount && (
                <p className="available-error-msg">
                  <span className="availablily-message">
                    Please update the quantity, only {stockLevel} left{' '}
                  </span>
                </p>
              )}
              {stockLevel !== undefined && stockLevel === 0 && !isSelectedSizeIsOOS && (
                <p className="available-error-msg">
                  <span className="availablily-message">This product is out of stock </span>
                </p>
              )}
            </div>
          ) : (
            <div className="dealSizeChangeMessage">Price may vary according to size</div>
          )}
          {!isProductIsOOS ? (
            <button
              className="full-width-button"
              id="updateQuantity"
              disabled={disableUpdateButton}
              tabIndex={disableUpdateButton ? -1 : 0}
              onClick={() => {
                this.props
                  .updateQuantity(modalName, {
                    entryNumber,
                    newQty: currentCount,
                    code,
                    size: beautyVolume ? code : size,
                    itemData
                  })
                  .then(() => this.updateProductForDataGlinch(true))
                  .catch(() => this.updateProductForDataGlinch(false));
                ga('send', {
                  hitType: 'event',
                  eventCategory: 'Buttop tap',
                  eventAction: 'Current event for clicking on "update" button ',
                  eventLabel: 'Inventory change'
                });
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="full-width-button"
              id="updateQuantity"
              onClick={() => {
                window.location.reload();
              }}
            >
              OKAY
            </button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { cart = {}, flags = {} } = state;
  const { size, sizeDetails } = cart;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    newDesignLuxe,
    size,
    sizeDetails,
    newSizeRevampFlag: getNewSizeRevampFlag(flags),
    showBrandSizeFlag: getShowBrandSizeFlag(flags)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { code } = ownProps;
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductUpdationPopup);
